import { ReducerState } from './types'

export const downloadNotes = <T extends Record<string, unknown>>(rs: ReducerState<T>) => {
	// TODO - implement this
	console.log('TODO: Download notes', rs)
}
